<template>
	<type-wrapper class="type-H" padding>
		<type-grid row="1" margin v-if="showData.audio_url">
			<vue-audio :src="showData.audio_url" :name="showData.title" :photo="showData.photo"></vue-audio>
		</type-grid>
		<type-grid row="1" margin v-if="showData.video_url">
			<vue-video :breakpoint="time" @break-play="breakPlay"></vue-video>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 音视频框
	import mixin from '../mixin.js'
	import vueAudio from './vue-audio.vue'
	import vueVideo from './vue-video.vue'
	export default {
		name: 'type-H',
		mixins: [ mixin ],
		data() {
			return {
				time: -1
			}
		},
		created() {
			const userInfo = this.$userInfo.getData();
			if (!userInfo.name) {
				this.time = process.env.NODE_ENV === 'production' ? 15 : 2;
			}
		},
		methods: {
			breakPlay(data) {
				this.$contact().then(res => this.time = -1);
			}
		},
		components: {
			'vue-audio': vueAudio,
			'vue-video': vueVideo
		}
	}
</script>

<style scoped lang="less">
	.type-H{}
</style>
